import ContactHero from '../../../screens/customer/contact/ContactHero';
import ContactForm from '../../../screens/customer/contact/ContactForm';
import ContactDetail from '../../../screens/customer/contact/ContactDetail';
import ContactMap from '../../../screens/customer/contact/ContactMap';
import MyNavbar from '../../../components/customer/MyNavbar';
import Footer from '../../../components/customer/Footer';

const Contact = () => {
  return (
    <>
      <ContactHero />
      <ContactForm />
      <ContactDetail />
      <ContactMap />
      <MyNavbar />
      <Footer />
      
    </>
  );
};

export default Contact;
